// Control-plane API (company sign-up and lookup) — /api/saas/*
import instance from "config/axios";
import { get } from "services";

const SaasServices = {
  companyInfo: (slug) => get(`saas/companies/${encodeURIComponent(slug)}`),
  slugAvailable: (slug) => get("saas/slug-available", { slug }),
  // public microsite content of a company
  companyPage: (slug) => get(`saas/companies/${encodeURIComponent(slug)}/site`),
  // company website settings (signed in, inside the company)
  companySite: () => get("company-site"),
  saveCompanySite: async (obj) => {
    try {
      const res = await instance.put("company-site", obj);
      return res.data;
    } catch (error) {
      throw { message: error?.response?.data?.message || "Could not save the company website." };
    }
  },
  // Called directly (not via `post`) so a validation error keeps the field it belongs to.
  signup: async (obj) => {
    try {
      const res = await instance.post("saas/signup", obj);
      return res.data;
    } catch (error) {
      const body = error?.response?.data;
      throw { message: body?.message || "We couldn't create your company. Please try again.", field: body?.field };
    }
  },
};

export default SaasServices;
